import type { ServiceProvider, Vendor } from '@shopgnd/shared';
import {
  resolveDirectoryClassification,
  type DirectorySector,
} from '@shopgnd/shared';

export function resolveEntryDirectory(
  vendor: Vendor,
  linkedPro?: ServiceProvider,
): { sector: DirectorySector; categoryId: string } {
  return resolveDirectoryClassification({
    directorySector: vendor.directorySector,
    directoryCategoryId: vendor.directoryCategoryId,
    businessType: vendor.businessType,
    proCategoryIds: linkedPro?.categories,
    primaryMode: vendor.primaryMode,
  });
}
